import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: journal/JournalDto.java's DestinationDto. Content, never a client route string — either
// a screen or a land (plus an optional activity code the client opens with `?open=`). Null for
// weeklies.
export type DailyDestination = { screen?: 'habitat' | null; land?: string | null; open?: string | null };

// Server: journal/JournalDto.java's TaskDto. Dailies have no counted progress (a daily's target
// is always 1 — either done or not), so progress/target are simply absent for them; weeklies
// always carry both.
export type JournalTaskDto = {
  code: string;
  label: string;
  done: boolean;
  progress?: number;
  target?: number;
  destination?: DailyDestination | null;
};

// Server: journal/JournalDto.java's StreakDto.
export type StreakDto = {
  length: number;
  restTokens: number;
  todayCounted: boolean;
  nextMoteIn: number;
};

export type JournalDto = {
  dailies: JournalTaskDto[];
  weeklies: JournalTaskDto[];
  streak: StreakDto;
  dailyResetAt: string;
  weeklyResetAt: string;
};

export const journalKeys = {
  all: ['journal'] as const,
};

export const getJournal = () => apiFetch<JournalDto>('/journal');

/** `enabled`: `MeScreen` disarms its queries around logout (see `useBadges` for the race). */
export function useJournal(enabled = true) {
  return useQuery({ queryKey: journalKeys.all, queryFn: getJournal, enabled });
}
